module.exports = __webpack_public_path__ + "img/medal-point.f065567f.svg";